<script>

/**
 * 運搬終了報告、処分終了報告
 * 個別表示情報
 * @param manifest { Object }
 * @property manifest.manifest_no {String} マニフェストNo
 * @property manifest.order_no { String } 受注番号
 * @property manifest.request_no {String} 発注番号
 * @property manifest.order_type { String } 受注種別
 * @property manifest.target_for_registration { Boolean } 登録対象
 * @property manifest.collected_date {String} 回収日
 * @property manifest.emission_name {String} 排出事業者名
 * @property manifest.emission_location_name {String} 排出事業場名
 * @property manifest.transport_route_name {String}
 * @property manifest.trader_name {String}
 * @property manifest.item_name {String}
 * @property manifest.waste_name {String}
 * @property manifest.quantity {Number}
 * @property manifest.quantity_unit_name {String}
 * @property manifest.quantity_confirm_name {String}
 * @property manifest.section {Number}
 * @property manifest.sections {Array}
 * @property manifest.viewer_quantity { Number }
 *
 */
export default {
  name: "ManifestInformation",
  props: {
    /**
     * マニフェスト
     */
    manifest: {
      type: Object,
      default: () => {}
    },
    /**
     * 報告区分
     * completion_report: 個別
     * bulk: 一括
     */
    callerType: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {}
  },
  computed: {
    /**
     * 予約登録後365日経過によるチェックボックス無効化判定
     */
    isDisabledByExpiration() {
      return this.manifest.manifest_type === 'dxe_form' && this.manifest.old_reservation;
    }
  },
  watch: {
    isDisabledByExpiration(newValue) {
      // 365日以上経過している場合はチェックボックスをOFF
      if (newValue && this.manifest.target_for_registration) {
        this.manifest.target_for_registration = false;
        this.targetOfRegistrationChangeEvent();
      }
    }
  },
  mounted() {
    // 初期表示時に365日以上経過している場合はチェックボックスをOFF
    if (this.isDisabledByExpiration && this.manifest.target_for_registration) {
      this.manifest.target_for_registration = false;
    }
  },
  methods: {
    /**
     * チェックボックス チェンジイベント
     */
    targetOfRegistrationChangeEvent () {
      if (this.manifest.order_id) {
        this.$emit('targetOfRegistrationChange', this.manifest.order_id, this.manifest.target_for_registration)
      }
    },
  }
}
</script>

<template>
  <div style="width: 100%">
    <v-row v-if="callerType === 'bulk'" dense class="pb-5">
      <v-col cols="4">
        <h3>&nbsp;</h3>
      </v-col>
    </v-row>
    <v-row
      no-gutters
      style="flex-wrap: nowrap;"
    >
      <v-col
        v-if="callerType !== 'bulk'"
        cols="1"
        class="flex-grow-0 flex-shrink-0"
        style="margin-right: 8px;"
      >
        <div style="height: 100%;width: 100%;display: flex;align-items: center;justify-content: center;">
          <v-checkbox
            v-model="manifest.target_for_registration"
            :disabled="isDisabledByExpiration"
            dense
            @change="targetOfRegistrationChangeEvent"
            hide-details="auto"
          />
        </div>

      </v-col>
      <v-col
        cols="1"
        style="min-width: 100px; max-width: 100%;"
        class="flex-grow-1 flex-shrink-0"
      >
        <dl class="manifestDescription">

          <!-- 受発注番号 -->
          <div
            v-if="manifest.order_no || manifest.request_no"
          >
            <dt class="text-sm-caption">{{ manifest.order_no ? '受注' : '発注' }}番号</dt>
            <dd class="text-sm-caption">{{ manifest.order_no ? manifest.order_no : manifest.request_no }}</dd>
          </div>
          <!-- /受発注番号 -->

          <!-- マニフェスト番号 -->
          <div
            v-if="callerType !== 'bulk'"
          >
            <dt class="text-sm-caption">マニフェスト番号</dt>
            <dd class="text-sm-caption">{{ manifest.manifest_no || '-' }}</dd>
          </div>
          <!-- /マニフェスト番号 -->

          <!-- 回収日 -->
          <div
            v-if="callerType !== 'bulk' && ['completion_report', 'disposal_report'].includes(callerType)"
          >
            <dt class="text-sm-caption">回収日</dt>
            <dd class="text-sm-caption">{{ manifest.collected_date | date_format }}</dd>
          </div>
          <!-- /回収日 -->

          <!-- 排出事業者 -->
          <div
            v-if="callerType !== 'bulk'"
          >
            <dt class="text-sm-caption">
              排出事業者
            </dt>

            <dd class="text-sm-caption">
              {{ manifest.emission_name }}
              <br />
              {{ manifest.emission_location_name }}
            </dd>
          </div>
          <!-- /排出事業者 -->

          <!-- ルート -->
          <div
            v-if="callerType !== 'bulk'"
          >
            <dt class="text-sm-caption">ルート</dt>
            <dd class="text-sm-caption">
              {{ manifest.transport_route_name }}
            </dd>
          </div>
          <!-- /ルート -->

          <!-- 運搬先事業者 -->
          <div
            v-if="callerType !== 'bulk'"
          >
            <dt class="text-sm-caption">運搬先事業者</dt>
            <dd class="text-sm-caption">
              {{ manifest.trader_name }}
            </dd>
          </div>
          <!-- /運搬先事業者 -->

          <!-- 品目 -->
          <div
            v-if="callerType !== 'bulk'"
          >
            <dt class="text-sm-caption">品目</dt>
            <dd class="text-sm-caption">
              {{ manifest.item_name }}
              <span v-if="manifest.waste_name">（{{ manifest.waste_name }}）</span>
              <span v-if="manifest.order_type !== 'self_emission'">{{ manifest.viewer_quantity }}&nbsp;{{ manifest.quantity_unit_name }}</span>
            </dd>
          </div>
          <!-- /品目 -->

          <!-- 数量の確定者 -->
          <div
            v-if="callerType !== 'bulk'"
          >
            <dt class="text-sm-caption">数量の確定者</dt>
            <dd class="text-sm-caption">
              {{ manifest.quantity_confirm_name }}
            </dd>
          </div>
          <!-- /数量の確定者 -->

        </dl>

      </v-col>
    </v-row>

  </div>
</template>

<style scoped lang="scss">
.manifestDescription {
  & div {
    display:flex;
    justify-content: flex-start;
    padding: 0;
  }

  & dt {
    width: 120px;
    font-weight: bold;
  }

  & dd {
    margin-left: 0;
    width: calc(100% - 120px) !important;
  }
}

</style>
